import React from 'react'
import {Optional} from '../../../../Common/TypeHelper'
import {MBContentTitleTypography} from '../../Atoms/Typographies'
import {MBRequiredBadge} from '../../Atoms/Badges'
import {Spacer} from '../../../../Common/Components/Spacer'
import {MBContentTitleDivider} from '../../Atoms/Dividers'
import {MBLogoImg} from '../../Atoms/MBLogos'
import {PIMStack} from '../../Atoms/Layouts/Bases/PIMStack'

type ContentTitleProps = {
  logoUrl?: Optional<string>
  require?: boolean
  noMarginBottom?: boolean
  children: React.ReactNode
}
export const ContentTitle: React.VFC<ContentTitleProps> = (props) => {
  const marginBottom = props.noMarginBottom ? 0 : 24
  return (
    <Spacer mb={`${marginBottom}px`}>
      <PIMStack
        direction={'row'}
        alignItems={'center'}
        justifyContent={'space-between'}
        spacing={1}
      >
        <PIMStack direction={'row'} alignItems={'center'} spacing={2}>
          <MBContentTitleTypography>{props.children}</MBContentTitleTypography>
          {
            props.require && (
              <MBRequiredBadge/>
            )
          }
        </PIMStack>
        {
          props.logoUrl && (
            <MBLogoImg
              data-testid={'content-block-logo'}
              logoImgMaxHeight={'30px'}
              logoImgMaxWidth={'58px'}
              src={props.logoUrl}
              alt={'content-header-log'}
            />
          )
        }
      </PIMStack>

      <Spacer mt={'7px'}>
        <MBContentTitleDivider/>
      </Spacer>
    </Spacer>
  )
}
